import * as React from "react";
import { getParam } from "../getParam";
import { MyCard } from "../MyCard";
import { useConfig } from "../useConfig";
import { useFetch } from "../useFetch";
import { Balance } from "./Balance";
import { Received } from "./Received";
import { Unspent } from "./Unspent";
import { AssetTable } from "./AssetTable";
import { History } from "./History";
import { FEE_MAINNET, FEE_TESTNET } from "../Block";

const numberConverter = require("number-to-words");

export interface IBalanceProps {
  balance: number;
  baseCurrency: string;
  rvnUsdRate?: number;
}

export interface IReceivedProps {
  received: number;
  baseCurrency: string;
  rvnUsdRate?: number;
}

export function Address() {
  const address = getParam("address");
  const config = useConfig();
  const isFee = address === FEE_TESTNET || address === FEE_MAINNET;
  // Fee address has ~600k+ UTXOs (~200MB JSON) — never auto-download that.
  const unspent = useFetch(isFee ? "" : "/api/getaddressutxos/" + address);
  const data = useFetch("/api/addresses/" + address);

  if (!data) {
    return (
      <div className="page">
        <p className="muted">Loading address…</p>
      </div>
    );
  }

  let header = "UTXOs";
  if (Array.isArray(unspent)) header = header + " " + unspent.length.toLocaleString();

  return (
    <div className="page stack">
      <div className="kicker">Address</div>
      <h1 className="mono" style={{ fontSize: 18, margin: 0, wordBreak: "break-all" }}>
        {address}
      </h1>
      {isFee ? (
        <div className="banner">
          Network development fee address — 25% of coinbase and asset-issue fees land here
          (Core 3.0.0).
        </div>
      ) : null}
      <Balance
        balance={data.balance}
        baseCurrency={config ? config.baseCurrency : "TLS"}
      />
      <Received
        baseCurrency={config ? config.baseCurrency : "TLS"}
        received={data.received}
      />
      <MyCard header="Assets" body={<AssetTable assets={data.assets || []} />} />
      <MyCard header="History" body={<History address={address} />} />
      <MyCard
        header={header}
        body={
          isFee ? (
            <span className="dim">
              Too many UTXOs to list here —{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href={"/api/getaddressutxos/" + encodeURIComponent(address || "")}
              >
                open raw UTXO API
              </a>{" "}
              (very large).
            </span>
          ) : (
            <Unspent address={address} unspent={unspent} />
          )
        }
      />
    </div>
  );
}

export function formatNumber(num: number) {
  if (num === 0) return 0;
  if (!num) return null;
  if (typeof num !== "number") return null;
  num = Number(num.toFixed(2));
  const words = numberConverter.toWords(num);
  const numberString = num.toLocaleString();
  const capitalized = words.charAt(0).toUpperCase() + words.slice(1);
  return (
    <>
      <div>{numberString}</div>
      <div>
        <i>{capitalized}</i>
      </div>
    </>
  );
}

export function getTwoDecimalTrunc(num: number) {
  return Math.trunc(num * 100) / 100;
}
